// @ts-check
import { useState } from 'react';
import {
  StyledNavigationMenu,
  StyledMenu,
  StyledMenuItem
} from './NavigationMenu.style';
import useNavigationMenuItems from './useNavigationMenuItems';
import CopyUrlToClipboardMenuItem from './CopyUrlToClipboardMenuItem';
import { LBButton } from '@linearb/buzz';
import Icon from 'components/base/Icon';

const NavigationMenu = ({ Context }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigationMenuItems = useNavigationMenuItems(Context);

  return (
    <StyledNavigationMenu>
      <LBButton
        variant='link'
        size='icon'
        data-cy='link-menu'
        onClick={e => {
          e.stopPropagation();
          setAnchorEl(e.currentTarget);
        }}
      >
        <Icon name='LinkArrow' color='chambray' size='smaller' />
      </LBButton>

      <StyledMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        onBlur={() => setAnchorEl(null)}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <CopyUrlToClipboardMenuItem Context={Context} />
        {navigationMenuItems.map(menuItem => {
          const { name, Icon, onClick } = menuItem;
          const text = `Open in ${menuItem.name}`;
          return (
            <StyledMenuItem key={name} onClick={onClick}>
              <Icon />
              {text}
            </StyledMenuItem>
          );
        })}
      </StyledMenu>
    </StyledNavigationMenu>
  );
};

export default NavigationMenu;
